$(document).ready(function () {
    var $ = jQuery.noConflict();
    // ADS Field's logics
    var adsYes = $("[id*='IsAdditionalDwellingSupplement_Yes']");
    var adsNo = $("[id*='IsAdditionalDwellingSupplement_No']");
    var adsInput = $("#TaxCalculatorForm_TaxCalculatorForm_AmountOfAdditionalDwellingSupplement");

    if (adsInput.length && adsInput.val().length) {
        adsInput.closest('fieldset').show();
    }else {
        adsInput.closest('fieldset').hide();
    }

    adsYes.on('click', function () {
        adsInput.closest('fieldset').show()
    });
    adsNo.on('click', function () {
        adsInput.closest('fieldset').hide()
    });

    // Linked Transaction's Field Logic
    var linkedInput = $("#TaxCalculatorForm_TaxCalculatorForm_TotalPriceOfAllLinkedTransactions");
    var linkedYes = $("[id*='IsLinkedTransaction_Yes']");
    var linkedNo = $("[id*='IsLinkedTransaction_No']");

    if (linkedInput.length && linkedInput.val().length) {
        linkedInput.closest('fieldset').show();
    }else {
        linkedInput.closest('fieldset').hide();
    }

    linkedYes.on('click', function () {
        linkedInput.closest('fieldset').show()
    });
    linkedNo.on('click', function () {
        linkedInput.closest('fieldset').hide()
    });
});
